import "../../../../content/departments/media/media.css";
import * as React from 'react';
export default {
  React
};